import React, {useState} from "react"
import classes from "./CopyAddress.module.scss"

interface CopyAddressProps {
  className?: string
  text: string
}

function CopyAddress ({className, text}: CopyAddressProps) {

  const cls = [classes.wrap]
  const [showPopover, setShowPopover] = useState(false)

  if (className) {
    cls.push(className)
  }

  const copyTextHandler = () => {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        setShowPopover(true)
        setTimeout(() => {
          setShowPopover(false)
        }, 2000)
      })
    }
  }

  return (
    <div className={cls.join(" ")}>
      <div
        className={classes.icon}
        onClick={() => copyTextHandler()}
      />
      {showPopover && <div className={classes.popover}>Адрес скопирован</div>}
    </div>
  )
}

export default CopyAddress